import {
  CreateTaxonomyNodeValidator,
  MoveTaxonomyNodeValidator,
  TaxonomyNodeEntity,
  TaxonomyTreeResponse,
  UpdateTaxonomyNodeValidator,
  endpoints,
} from '@seaters/constants';

import { api } from '../axios-instance';

// Admin taxonomy catalog CRUD. Node API only (nginx routes `fgo/*` to Node),
// gated server-side by @PrototypeOnly() + admin role.
const basePath = endpoints.taxonomy;

export const fetchTaxonomyTree = (): Promise<TaxonomyTreeResponse> =>
  api.get(`${basePath}/${endpoints.tree}`);

export const createTaxonomyNode = (
  body: CreateTaxonomyNodeValidator
): Promise<TaxonomyNodeEntity> =>
  api.post(`${basePath}/${endpoints.nodes}`, body);

export const updateTaxonomyNode = (
  id: string,
  body: UpdateTaxonomyNodeValidator
): Promise<TaxonomyNodeEntity> =>
  api.patch(`${basePath}/${endpoints.nodes}/${id}`, body);

export const archiveTaxonomyNode = (id: string): Promise<TaxonomyNodeEntity> =>
  api.post(`${basePath}/${endpoints.nodes}/${id}/${endpoints.archive}`);

export const moveTaxonomyNode = (
  id: string,
  parentId: string
): Promise<TaxonomyNodeEntity> => {
  const body: MoveTaxonomyNodeValidator = { parentId };
  return api.post(
    `${basePath}/${endpoints.nodes}/${id}/${endpoints.move}`,
    body
  );
};
